// extracted by mini-css-extract-plugin
export default {"intro":"IntroList_intro__PRRjS","container":"IntroList_container__ry0cO","subheading":"IntroList_subheading__Pi7Wg"};